import { sanitizeHtml } from "@/components/RichTextEditor";

export const looksHtml = (s) => /<\/?(p|br|b|strong|i|em|u|h[1-6]|ul|ol|li|a|blockquote|div|span|font|img|iframe|video|figure)\b[^>]*>/i.test(s || "");

// Plain-text version of stored content (for clamped previews, meta tags, calendar files).
export function toPlainText(s) {
  if (!looksHtml(s)) return s || "";
  const d = document.createElement("div");
  d.innerHTML = sanitizeHtml(String(s).replace(/<\/(p|div|h[1-6]|li|blockquote)>/gi, "$&\n").replace(/<br\s*\/?>/gi, "\n"));
  return (d.textContent || "").replace(/\n{3,}/g, "\n\n").trim();
}

// Renders stored content: formatted HTML from the editor, or legacy plain text exactly as written.
export default function RichContent({ text, className = "", testid, preview = false }) {
  if (!text) return null;
  if (preview || !looksHtml(text)) {
    return <p className={`${preview ? "" : "whitespace-pre-line"} ${className}`} data-testid={testid}>{preview ? toPlainText(text) : text}</p>;
  }
  return <div className={`rich-content ${className}`} data-testid={testid} dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }} />;
}
